export const checkIsSatelliteDefined = () => {
  try {
    return !!_satellite && typeof _satellite.track === 'function';
  } catch {
    return false;
  }
};
